<template src="./login.html"></template>

<script>
export default {
  name: "LoginForm",

  data() {
    return {
      e1: true,
      cred: {
        username: "",
        password: "",
      },
      attesa: false,
    };
  },

  methods: {
    async submit() {
      window.scrollTo(0, 0);

      // Validazione
      if (!this.$refs.formLogin.validate()) {
        return;
      }

      this.attesa = true;

      try {
        // Login
        await this.$store.dispatch("auth/login", this.cred);

        // Vado alla pagina originariamente richiesta (es. link diretto a una
        // macchina da QR code), se presente; altrimenti alla home come sempre.
        const destinazione = this.$route.query.redirect || "/";
        this.$router.push(destinazione);
      } catch (error) {
        console.log(error);
        //this.$toast.alert(this.$functions.getErrorMsg(error));
      }

      this.attesa = false;
    },
  },
};
</script>